namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_page, {

		background: {
			color: 'transparent',
		},

	} )
	
}
